import { forwardRef, ReactNode } from 'react';
import * as Primitive from '@radix-ui/react-select';
import { Check } from 'lucide-react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

type SelectOptionProps = Primitive.SelectItemProps & {
  description?: ReactNode;
  icon?: ReactNode;
};

const SelectOption = forwardRef<HTMLDivElement, SelectOptionProps>(
  function SelectOption(
    { children, value, className, description, icon, ...props },
    ref
  ) {
    return (
      <Primitive.Item
        ref={ref}
        className={cn(css.item, className)}
        value={value}
        {...props}
      >
        <div className={css.itemContent}>
          <Primitive.ItemText asChild>
            <span className={css.itemLabel}>
              {icon && (
                <span className={css.itemLabelIcon} aria-hidden>
                  {icon}
                </span>
              )}
              <span className={css.itemLabelText}>{children}</span>
            </span>
          </Primitive.ItemText>

          {description && <p className={css.itemDescription}>{description}</p>}
        </div>

        <Primitive.ItemIndicator>
          <Check className={css.check} aria-hidden />
        </Primitive.ItemIndicator>
      </Primitive.Item>
    );
  }
);

export default SelectOption;
